import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
// import { toast } from "react-toastify";
import { useToaster } from "../_components/toaster/MuiToasterProvider";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { langConversionHelper } from "@/_helpers";
import { TimeLoader } from "@/_components";
import { userLoginSuccess } from "../_redux/actions/accountActions";
import { accountService } from "@/_services";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
const LoginForm = styled("form")(({ theme }) => ({
  width: "100%",
  marginTop: theme.spacing(1),

  "@media (max-height: 700px)": {
    marginTop: 0,
  },
}));
const SubmitButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(3, 0, 2),
  width: 240,
  height: 50,

  "@media (max-height: 700px)": {
    margin: theme.spacing(2, 0, 1),
  },

  "@media (max-height: 560px)": {
    margin: theme.spacing(1.25, 0, 0.75),
  },
}));
const PersonIcon = styled(PersonOutlineOutlinedIcon)(() => ({
  opacity: 0.6,
  color: "#1c355e",
}));
const LockIcon = styled(LockOutlinedIcon)(() => ({
  opacity: 0.6,
  color: "#1c355e",
}));
const LOGIN_TIMEOUT_MS = 30000;
const LOGIN_TIMEOUT_MESSAGE =
  "Login is taking too long. Please check your connection and try again.";
const LOGIN_FAILED_MESSAGE = "Login failed. Please try again.";

function getLoginErrorMessage(error) {
  if (error?.name === "AbortError") {
    return LOGIN_TIMEOUT_MESSAGE;
  }
  if (typeof error === "string") {
    return error;
  }
  return error?.reason || LOGIN_FAILED_MESSAGE;
}

function Login({ history, location, userLoginSuccess }) {
  const { t, i18n } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const [isPhone, setIsPhone] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const toast = useToaster();
  const [values, setValues] = useState({
    showPassword: false,
  });
  // let token =
  //   "aDlnUWhFdHJOYVZxdzAvVmFXRHNDTmpmck9EbW5SRzcycGlpcEk5cEJwME5FL1RVc0VnY0xFd0h4QmowVnpZbDNrUVpFR2Qyb1dVNFYzZ3hEdTc1Zm9kRlpFUzlmTVRP";
  const {
    register,
    handleSubmit,
    trigger,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const onSubmit = async (data) => {
    if (submitting) {
      return;
    }

    setSubmitting(true);
    const abortController = new AbortController();
    const timeoutId = window.setTimeout(() => {
      abortController.abort();
    }, LOGIN_TIMEOUT_MS);
    let redirectTo = null;

    try {
      let phoneData = "";
      if (isPhone && data.email) {
        phoneData = data.email.replace(/\D/g, "");
      } else {
        phoneData = data.email || "";
      }

      const user = await accountService.login(
        phoneData,
        data.password,
        isPhone ? isPhone : false,
        { signal: abortController.signal },
      );

      userLoginSuccess();
      let i18nextLocalStorage = localStorage.getItem("i18nextLng");
      if (user.languageID !== undefined) {
        i18n.changeLanguage(
          langConversionHelper.findLanguageAbbrev(user.languageID),
        );
      } else if (i18nextLocalStorage === null) {
        i18n.changeLanguage(langConversionHelper.findLanguageAbbrev(1));
      }

      const { from } = location.state || {
        from: {
          pathname: "/",
        },
      };
      redirectTo = from;
    } catch (error) {
      toast.error(getLoginErrorMessage(error));
    } finally {
      window.clearTimeout(timeoutId);
      setSubmitting(false);
    }

    if (redirectTo) {
      history.push(redirectTo);
    }
  };
  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleInputChange = (event) => {
    let { value } = event.target;
    const hasAt = value.includes("@");
    const hasLetter = /[a-zA-Z]/.test(value || "");
    let isPhoneValue = false;
    if (hasAt || hasLetter) {
      setIsPhone(false);
      isPhoneValue = false;
    } else {
      setIsPhone(true);
      isPhoneValue = true;
    }
    if (countryCode === "USA" && isPhoneValue) {
      const numericValue = value.replace(/[^\d]/g, "");
      if (numericValue.length > 3 && numericValue.length <= 6) {
        value = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
      } else if (numericValue.length > 6) {
        value = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6, 10)}`;
      }
    } else {
      value = value.replace(/[^a-zA-Z\d@.+_-]/g, "");
    }
    setInputValue(value);
  };
  return (
    <LoginForm onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name="email"
        control={control}
        defaultValue={inputValue}
        rules={{
          required: {
            value: true,
            message:
              countryCode === "USA"
                ? t("account.phoneEmailRequired")
                : t("account.emailRequired"),
          },
          // if (countryCode === "AU" || hasAt) {
          //   const isValidEmail = /^\S+@\S+\.\S+$/.test(cleanValue);
          //   return isValidEmail ? true : t("account.emailValid");
          // } else {
          //   return t("account.invalidNumber");
          // }
          validate: (value) => {
            if (countryCode === "USA" && !value) {
              return t("account.phoneEmailRequired");
            }
            const cleanValue = value.trim();
            const hasAt = cleanValue.includes("@");
            const hasLetter = /[a-zA-Z]/.test(cleanValue || "");
            if (countryCode === "AU" || hasAt || hasLetter) {
              const isValidEmail = /^\S+@\S+\.\S+$/.test(cleanValue);
              return isValidEmail ? true : t("account.emailValid");
            } else {
              // const numericValue = cleanValue.replace(/[^\d]/g, "");
              if (
                value.replace(/\D/g, "").length === 10 ||
                value.replace(/\D/g, "").length === 11 ||
                value.length === 0
              ) {
                return true;
              } else {
                return t("account.phoneValid");
              }
              // return /^\d{10}$/.test(numericValue)
              //   ? true
              //   : t("account.phoneValid");
            }
          },
        }}
        render={({ field: __fieldField }) => {
          const field = {
            ...__fieldField,
            value: __fieldField.value ?? null,
          };
          return (
            <TextField
              {...field}
              data-cy="email"
              variant="outlined"
              margin="normal"
              size="small"
              fullWidth
              id="email"
              label={
                countryCode === "USA"
                  ? t("account.phoneEmail")
                  : t("account.email")
              }
              name="email"
              autoComplete="email"
              error={!!errors.email}
              helperText={errors.email ? errors.email.message : ""}
              onChange={(e) => {
                handleInputChange(e);
                field?.onChange(e);
                trigger("email");
              }}
              value={inputValue}
              maxLength={10}
              autoFocus
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                },
              }}
            />
          );
        }}
      />

      <TextField
        data-cy="password"
        variant="outlined"
        margin="normal"
        fullWidth
        id="password"
        label={t("account.password")}
        name="password"
        size="small"
        autoComplete="current-password"
        type={values.showPassword ? "text" : "password"}
        error={!!errors.password}
        helperText={errors.password ? errors.password.message : ""}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <LockIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  size="large"
                >
                  {values.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          },
          htmlInput: {
            ...register("password", {
              required: {
                value: true,
                message: t("account.passwordRequired"),
              },
            }),
          },
        }}
      />
      <Grid
        container
        style={{
          paddingTop: 10,
        }}
        sx={{
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <RouterLink
          to="forgot-password"
          variant="body2"
          style={{
            color: "#76bc21",
            textDecoration: "none",
          }}
          disabled={submitting}
          data-cy="forgotPassword"
        >
          {t("account.passwordForgot")}
        </RouterLink>
      </Grid>
      <Grid
        container
        sx={{
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Grid>
          {submitting === false ? (
            <Grid>
              <Grid>
                <SubmitButton
                  type="submit"
                  size="medium"
                  variant="contained"
                  color="primary"
                  disabled={submitting}
                  data-cy="signInButton"
                >
                  {t("account.signInButton")}
                </SubmitButton>
              </Grid>

              {/* <Grid
                style={{
                  textAlign: "center",
                  margin: 25,
                }}
              >
                <RouterLink
                  style={{
                    color: "#6DA9B3",
                    fontWeight: "bold",
                  }}
                  to="/register"
                  data-cy="createAccountLink"
                >
                  {t("registration.createAccount")}
                </RouterLink>
              </Grid> */}

              {/* <Grid item style={{ textAlign: "center", margin: 25 }}>
                <RouterLink
                  style={{ color: "#6DA9B3", fontWeight: "bold" }}
                  to={`/signnow/${token}`}
                  data-cy="createAccountLink"
                >
                  Sign Now
                </RouterLink>
               </Grid>
               <Grid item style={{ textAlign: "center", margin: 25 }}>
                <RouterLink
                  style={{ color: "#6DA9B3", fontWeight: "bold" }}
                  // to="/idupload"
                  to={{ pathname: `/idupload/${token}` }}
                  data-cy="createIDUploadLink"
                >
                  {t("account.idUpload")}
                </RouterLink>
               </Grid>
               <Grid item style={{ textAlign: "center", margin: 25 }}>
                <RouterLink
                  style={{ color: "#6DA9B3", fontWeight: "bold" }}
                  to={`/autopay/${token}`}
                  data-cy="createAutoPay"
                >
                  Auto Pay
                </RouterLink>
               </Grid> */}
            </Grid>
          ) : (
            <div
              style={{
                paddingTop: 20,
              }}
            >
              <TimeLoader />
            </div>
          )}
        </Grid>
      </Grid>
    </LoginForm>
  );
}
Login.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object.isRequired,
  userLoginSuccess: PropTypes.func,
};
function mapStateToProps(state) {
  return {
    userLoginSuccess: state.userLoginSuccess,
  };
}
const mapDispatchToProps = {
  userLoginSuccess,
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
